import React from 'react'
import "../components/Spinner.css"

export default function Spinner() {
    return (
        <div className='spinner W-full mx-auto'></div>
    )
}
